var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayCircle = function SvgPlayCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    className: "icon",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M512 1024A512 512 0 1 1 512 0a512 512 0 0 1 0 1024m3.008-92.992a416 416 0 1 0 0-832 416 416 0 0 0 0 832M383.232 287.616l384 224.896-384 223.104z"
  })));
};
export { SvgPlayCircle as ReactComponent };
export default "/_next/static/images/play-circle.svg";